import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionSchedulesService } from '../services/constructionSchedules.service';
import type { ConstructionSchedule } from '../types/construction-schedules.types';
import { toast } from 'sonner';

export function useConstructionScheduleDetail(id?: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-schedules', 'detail', id],
    queryFn: () => ConstructionSchedulesService.getScheduleDetail(id!),
    enabled: !!id,
  });

  const updateMutation = useMutation({
    mutationFn: (updates: Partial<ConstructionSchedule>) => ConstructionSchedulesService.updateSchedule(id!, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-schedules'] });
      queryClient.invalidateQueries({ queryKey: ['construction-schedules', 'detail', id] });
      toast.success('Cập nhật lịch thi công thành công');
    },
  });

  return {
    schedule: query.data,
    isLoading: query.isLoading,
    updateSchedule: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}
